<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHome_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.751 8.035A2 2 0 0 0 3 9.597v10.347c0 .545.21 1.068.586 1.454C3.96 21.783 4.47 22 5 22h3.756v-9.078c0-.506.363-.917.811-.917h4.867c.448 0 .81.41.81.917V22H19c.53 0 1.04-.217 1.414-.602.375-.386.586-.909.586-1.454V9.597a2 2 0 0 0-.751-1.562l-7-5.597a2 2 0 0 0-2.498 0l-7 5.597Z"
        clip-rule="evenodd"
    />
</svg>
